import { Box, Step, StepLabel, Stepper, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';


function formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
}

export function sortByTimestamp(array, key) {
    let newarray = array?.slice().sort((a, b) => new Date(b[key]) - new Date(a[key]));
    return newarray;
}


export function parseDateAndTime(dateTime, dateWithYear = false) {
    if(!dateTime) return "";
    const monthNames = ["Jan", "Feb", "March", "April", "May", "June",
        "July", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const modifiedDateTime = new Date(dateTime);
    if (dateWithYear) {
        return modifiedDateTime.getDate() + " " + monthNames[modifiedDateTime.getMonth()] + " " + modifiedDateTime.getFullYear();
    }

    return modifiedDateTime.getDate() + " " + monthNames[modifiedDateTime.getMonth()] + ", " + formatAMPM(modifiedDateTime);
}

function getStatusColor(currentStatus, palette) {
    if (currentStatus?.includes('DELIVERED')) return palette.success.main;
    if (currentStatus?.includes('FAILED')) return palette.error.main;
    return palette.primary.main;
}

function TimelineDot({ isFirst, color }) {
    if (isFirst) {
        return (
            <Box sx={{
                width: 14,
                height: 14,
                borderRadius: '50%',
                bgcolor: color,
                boxShadow: `0 0 0 4px ${color}25`,
                animation: 'pulse-dot 2s infinite',
                position: 'relative',
            }} />
        );
    }
    return (
        <Box sx={{
            width: 10,
            height: 10,
            borderRadius: '50%',
            bgcolor: '#e0e0e0',
            border: '2px solid #f5f5f5',
        }} />
    );
}

const OrderTimeline = ({ orderDetailInfo, resolvedStatusColor }) => {
    const theme = useTheme();
    const order_history = (orderDetailInfo.order_history) ? sortByTimestamp(orderDetailInfo.order_history, "timestamp") : [];
    const currentStage = order_history.length;
    const statusColor = resolvedStatusColor ?? getStatusColor(orderDetailInfo.currentStatus, theme.palette);

    return (
        <Stepper
            activeStep={currentStage}
            orientation="vertical"
            sx={{
                '& .MuiStepConnector-line': {
                    borderLeftWidth: 2,
                    borderColor: '#eeeeee',
                    minHeight: 24,
                },
            }}
        >
            {order_history.map((item, index) => {
                const isFirst = index === 0;

                return (
                    <Step key={index}>
                        <StepLabel
                            icon={<TimelineDot isFirst={isFirst} color={statusColor} />}
                            sx={{
                                '& .MuiStepLabel-iconContainer': {
                                    pr: 2,
                                },
                            }}
                        >
                            <Box sx={{
                                p: 1.5,
                                borderRadius: 2,
                                ...(isFirst ? {
                                    bgcolor: 'rgba(0,0,0,0.02)',
                                    border: '1px solid rgba(0,0,0,0.06)',
                                } : {}),
                            }}>
                                <Typography variant="body2" fontWeight={isFirst ? 600 : 400} color={isFirst ? 'text.primary' : 'text.secondary'}>
                                    {item.orderStatusDescription}
                                </Typography>
                                <Box sx={{ mt: 0.5, display: 'flex', flexDirection: 'column', gap: 0.25 }}>
                                    {item.currentLocation && (
                                        <Typography variant="caption" color="text.secondary">
                                            {item.currentLocation}
                                        </Typography>
                                    )}
                                    {item.remark && (
                                        <Typography variant="caption" color="text.disabled" sx={{ fontStyle: 'italic' }}>
                                            {item.remark}
                                        </Typography>
                                    )}
                                    <Typography variant="caption" color="text.disabled" sx={{ mt: 0.25 }}>
                                        {parseDateAndTime(item.timestamp)}
                                    </Typography>
                                </Box>
                            </Box>
                        </StepLabel>
                    </Step>
                );
            })}
        </Stepper>
    );

}
export default OrderTimeline;
